import { theme } from '@theme';
import styled from 'styled-components';

type SideNavDivProps = {
  width: string;
};
type NavLinkProps = {
  display?: string;
  alignItem?: string;
  whiteSpace?: string;
};
type MainMenuProps = {
  paddingLeft?: string;
  whiteSpace?: string;
};
type MenuItemProps = {
  display?: string;
  color?: string;
  marginLeft?: number;
  fontWeight?: number;
  width?: string;
  whiteSpace?: string;
  flexShrink?: number;
  maxWidth?: string;
  wordBreak?: string;
};
type MainMenuItemListProps = {
  isSelected?: boolean;
  paddingTop?: number;
};

type IconWrapperProps = {
  alignItem?: string;
  height?: string;
};

type MainMenuColumnWrapperProps = {
  isSelected?: boolean;
};
export const SideNavDiv = styled.div<SideNavDivProps>`
  z-index: 299 !important;
  background: ${theme.palette.sidebarGradient.from};
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transition: 0.3s;
  height: 100vh;
  width: ${(props) => props.width ?? props.width};
`;

export const Header = styled.div`
  font-size: x-large;
  color: ${theme.palette.white};
  margin: 5px;
  float: left;
  font-weight: ${theme.typography.fontWeights.bold};
  font-style: italic;
  margin: 0 15px;
  width: 100px;
`;

export const HeaderArea = styled.div`
  display: flex;
  padding: 10px 10px 0px 10px;
`;

export const HeaderImage = styled.img`
  height: 15px;
`;

export const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: ${(props) => (props.alignItem ? props.alignItem : 'center')};
  justify-content: center;
  width: 60px;
  height: ${(props) => (props.height ? props.height : '40px')};
  flex: 0 0 auto;
`;
export const NavLink = styled.a.attrs({})<NavLinkProps>`
  display: ${(props) => (props.display ? props.display : 'flex')};
  align-items: ${(props) => (props.alignItem ? props.alignItem : 'center')};
  color: ${theme.palette.white};
  cursor: pointer;
  text-decoration: none !important;
  transition: 0.3s;
  white-space: ${(props) => props.whiteSpace ?? props.whiteSpace};
`;

export const BottomMenu = styled.div`
  background: ${theme.palette.white};
  width: 79vw;
  height: auto;
  gap: 0px;
  border-radius: 5px;
  margin-top: 25px;
  margin-left: 11px;
  padding-bottom: 20px;
`;

export const MainMenu = styled.ul<MainMenuProps>`
  margin: 0;
  padding: 0px 9px 0px ${(props) => (props.paddingLeft ? props.paddingLeft : '0')}px;
  list-style-type: none;
  .row {
    display: flex;
    width: 87vw;
  }
`;

export const MainMenuItemList = styled.li<MainMenuItemListProps>`
  margin-top: 10px;
  font-weight: ${theme.typography.fontWeights.bold};
  background-color: ${(props) => (props.isSelected ? theme.palette.toolTipBackground : '')};
  border-radius: ${(props) => (props.isSelected ? '6px' : 'none')};
  padding-top: ${(props) => props.paddingTop ?? props.paddingTop}px;
`;

export const MainMenuColumnWrapper = styled.li<MainMenuColumnWrapperProps>`
  margin-top: 10px;
  font-weight: ${theme.typography.fontWeights.bold};
  background-color: ${(props) => (props.isSelected ? theme.palette.toolTipBackground : '')};
  border-radius: ${(props) => (props.isSelected ? '6px' : 'none')};
  margin-left: 15px;
  padding-left: 0px;
  margin-right: 0px;
  width: 45%;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

export const NavBottomText = styled.div`
  display: block;
  margin-top: 10px;
  text-align: center;
`;

export const StoreName = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: -13px;
`;

export const MenuItem = styled.span<MenuItemProps>`
  background-color: ${theme.palette.transparent};
  font-size: medium;
  font-weight: ${(props) =>
    props.fontWeight ? props.fontWeight : theme.typography.fontWeights.normal};
  margin: 0px 0px 0px ${(props) => (props.marginLeft ? props.marginLeft : '0')}px;
  color: ${(props) => props.color ?? props.color};
  display: ${(props) => (props.display ? props.display : 'inline')};
  padding: 0px;
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
  width: ${(props) => props.width ?? props.width};
  white-space: ${(props) => props.whiteSpace ?? props.whiteSpace};
  flex-shrink: ${(props) => props.flexShrink ?? props.flexShrink};
  max-width: ${(props) => props.maxWidth ?? props.maxWidth};
  word-break: ${(props) => props.wordBreak ?? props.wordBreak};
`;

export const ChangeButton = styled.div`
  font-size: medium;
  position: relative;
  font-weight: ${theme.typography.fontWeights.normal};
  margin-left: auto;
  padding-right: 5px;
  padding-left: 10px;
`;
